import { useState, useEffect } from "react";
import { usePersistData } from "../../store";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import SearchIcon from "../../components/Icons/searchIcon";
import { Button } from "../../components";
import { Profile } from "../../assets/images";

const Layout = ({ children, originalData = [] }) => {
  const { user } = usePersistData();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(originalData);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (!query.trim()) {
      window.history.back();
      setFilteredData(originalData);
    }
  };

  const handleSearch = (e) => {
    if (e.key === "Enter" && searchQuery.trim()) {
      const basePath = location.pathname.split("/")[1];
      navigate(`/${basePath}/?query=${encodeURIComponent(searchQuery)}`);
    }
  };

  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = originalData.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, []);

  return (
    <div>
      <div className="flex h-screen overflow-hidden">
        <Dashboard className="fixed" />
        <div className="w-[calc(100vw-280px)]">
          <header className="bg-white h-20 border border-b border-color-6">
            <div className="flex my-[18px] mx-[40px] justify-between">
              {/* Search Bar */}
              <div className="flex w-full">
                {location.pathname.startsWith("/leave") ||
                location.pathname.startsWith("/employee") ? (
                  <div className="flex w-full justify-center items-center max-w-lg relative gap-[2px]">
                    <div className="h-[20px] w-[20px] text-color-7 absolute left-3 top-1/2 transform -translate-y-1/2">
                      <SearchIcon />
                    </div>
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      onKeyDown={handleSearch}
                      className="w-full p-2 pl-10 border border-border shadow-sm rounded-md px-3"
                    />
                  </div>
                ) : null}
              </div>

              {/* Notification & Profile */}
              <div className="flex gap-x-2 items-center">
                <div>
                  <Button
                    variant="noStyle"
                    onClick={() => navigate("/userProfile")}
                  >
                    {user?.employeeImageUrl ? (
                      <img
                        src={user.employeeImageUrl}
                        alt="User Profile"
                        className="rounded-full h-[40px] w-[40px]"
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      <img
                        src={Profile}
                        alt="NO User"
                        className="h-[50px] w-[50px]"
                      />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </header>

          <main className="h-full overflow-scroll pb-[60px] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
